
export const Product = [

    {
        id:"1",
    name:"Men's Nike Air Max Excee Sneakers",
    type:"men",
    brand:'Nike',
    src:"https://i8.amplience.net/s/scvl/103543_205155_SET/1?fmt=auto&$webPdpProduct$",
    des:"Celebrate a classic throwback favorite with a fresh new lens with the Nike Air Max Excee. Inspired by the Nike Air Max 90, these sneaks are anything but weak - crafted with a durable, yet breathable upper, a supportive and stylish visible Air midsole, and a super soft cushioned insole, it'll be a challenge not to love them the moment you lace them up!",
    prize:"2500",
    offerPize:2299,
    qty:1
    
},
{ id:"2",
    name:"Men's Nike Air Max Systm Sneakers",
    type:"men",
    brand:'Nike',
    src:"https://i8.amplience.net/s/scvl/127482_309710_SET/1?fmt=auto&$webPdpProduct$",
    des:"The Nike Air Max Systm sneaker is the perfect combination of style and performance. Made with a lightweight and breathable upper, this shoe offers a comfortable and secure fit.",
    prize:"3000",
    offerPize:2800,
    qty:1
},
{ id:"3",name:"Men's Nike Legend Essential 2 Training Shoes",
    type:"men",
    brand:'Nike',
    src:"https://i8.amplience.net/s/scvl/112886_244780_SET/1?fmt=auto",
    des:"Ladies and gents, the icon has arrived! Nike's Air Max SC Sneakers are everything we all know and love about Nike: they have an effortlessly stylish design with comfort features like Nike's Comfort Insoles and their classic Air Max midsole that ensure that every step is comfortable and supported",
    prize:"2557",
    offerPize:2360, qty:1
},
{ id:"4",name:"Men's Nike Air Max SC Sneakers",
    type:"men",
    brand:'Nike',
    src:"https://i8.amplience.net/s/scvl/113686_234097_SET/1?fmt=auto",
    des:" Nike's Air Max SC Sneakers are everything we all know and love about Nike: they have an effortlessly stylish design with comfort features like Nike's Comfort Insoles and their classic Air Max midsole that ensure that every step is comfortable and supported.",
    prize:"2900",
    offerPize:2750, qty:1
},
{ id:"5",name:"MEN'S ADIDAS KAPTIR RUNNING SHOES",
    type:"men",
    brand:'Adidas',
    src:"https://i8.amplience.net/s/scvl/120453_252556_SET/1?fmt=auto",
    des:"Morning runs make for good-looking strides in your Duramo 10 men's running shoe. With a 50% recycled content mesh & synthetic upper and no-sew overlays for extra support, this lace-up shoe is just another solutions to help end plastic waste.",
    prize:"1988",
    offerPize:1900, qty:1
},
{ id:"6",name:"BOYS' ADIDAS  RUNNING  SHOES",
    type:"men",
    brand:'Adidas',
    src:"https://i8.amplience.net/s/scvl/115450_268720_SET/1?fmt=auto",
    des:" He'll be the fastest kid in the whole grade after he laces up his new adidas Racer TR 21 Running Shoes, without a shadow of a doubt. Lightweight, breathable, and durable enough to keep up, the Racer TR 21 features an easy to wear design and construction that assists him with every stride, while the soft and supportive Cloudfoam midsole gives him the perfect edge to outrun his competition!.",
    prize:"3500",
    offerPize:3000, qty:1
},
{ id:"7",name:"MEN'S ADIDAS RUNNING SHOES ",
    type:"men",
    brand:'Adidas',
    src:"https://i8.amplience.net/s/scvl/111383_227210_SET/1?fmt=auto",
    des:" New adidas Racer TR 21 Running Shoes, without a shadow of a doubt. Lightweight, breathable, and durable enough to keep up, the Racer TR 21 features an easy to wear design and construction that assists him with every stride, while the soft and supportive Cloudfoam midsole gives him the perfect edge to outrun his competition!.",
    prize:"3000",
    offerPize:2980, qty:1
},
{ id:"8",name:"Men's Adidas Lite Racer Adapt 5.0 Slip-On Sneakers ",
    type:"men",
    brand:'Adidas',
    src:"https://i8.amplience.net/s/scvl/113069_306325_SET/1?fmt=auto",
    des:" Lightweight, breathable, and durable enough to keep up, the Racer TR 21 features an easy to wear design and construction that assists him with every stride, while the soft and supportive Cloudfoam midsole gives him the perfect edge to outrun his competition!.",
    prize:"3070",
    offerPize:2990, qty:1
},

{ id:"9",name:"PWR  Training Shoes At the nexus of street",
    type:"men",
    brand:'Puma',
    src:"https://i8.amplience.net/s/scvl/114874_242982_SET/1?fmt=auto&$webPdpProduct$" ,
    des:"Step into the future. At the nexus of street and tech sits the undeniable fashion and performance of our pwrframe collection. Originally engineered for the football pitch, this innovative shoe features a continuous ring of support from heel to midfoot, unparalleled comfort matched only with head turning design.",
    prize:"2890",
    offerPize:2080, qty:1
},
{ id:"10",name:"WOMEN'S NIKE AIR MAX EXCEE SNEAKERS",
    type:"women",
    brand:'Nike',
    src:"https://i8.amplience.net/s/scvl/103699_319009_SET/1?fmt=auto" ,
    des:"Step into the future. At the nexus of street and tech sits the undeniable fashion and performance of our pwrframe collection. Originally engineered for the football pitch, this innovative shoe features a continuous ring of support from heel to midfoot, unparalleled comfort matched only with head turning design.",
    prize:"2360",
    offerPize:2300, qty:1
},
{ id:"11",
name:"WOMEN'S ROCKET DOG CHEERY PLATFORM",
    type:"women",
    brand:'Nike',
    src:"https://i8.amplience.net/s/scvl/111593_227981_SET/1?fmt=auto" ,
    des:"Cute, casual, and everything you've been needing to update your look: the Cheery by Rocket Dog® is the perfect choice for any outfit!",
    prize:"3508",
    offerPize:3200, qty:1
},
{ id:"12",
name:"WOMEN'S ROCKET DOG CHEERY PLATFORM",
    type:"women",
    brand:'Nike',
    src:"https://i8.amplience.net/s/scvl/111593_268138_SET/1?fmt=auto" ,
    des:"Casual and everything you've been needing to update your look: the Cheery by Rocket Dog® is the perfect choice for any outfit!",
    prize:"3700",
    offerPize:3500, qty:1
},
{ id:"13",
name:"CHUCK TAYLOR ALL STAR LIFT HI HIGH-TOP",
    type:"women",
    brand:'Nike',
    src:"https://i8.amplience.net/s/scvl/108346_229785_SET/1?fmt=auto" ,
    des:"The Converse Lift Hi Platform sneaker offers a stylish twist on the classic Chuck Taylor design with a trendy, elevated platform sole. These sneakers feature a durable canvas upper, lace-up closure for a secure fit, and iconic Converse branding on the tongue and heel. ",
    prize:"4200",
    offerPize:4000, qty:1
},
{ id:"14",
name:"WOMEN'S ADIDAS GRAND COURT 2.0 SNEAKERS",
    type:"women",
    brand:'Adidas',
    src:"https://i8.amplience.net/s/scvl/126164_315781_SET/1?fmt=auto&$webPdpProduct$" ,
    des:"Combining the classic Grand Court design with Cloudfoam Comfort cushioning plus a little flower power, these are the perfect balance of sporty and feminine.",
    prize:"5000",
    offerPize:4800, qty:1
},
{ id:"15",
name:"WOMEN'S NEW BALANCE ROAV V1 SLIP-ON SNEAKERS",
    type:"women",
    brand:'Adidas',
    src:"https://i8.amplience.net/s/scvl/154934_235013_SET/1?fmt=auto&$webPdpProduct$" ,
    des:"An ultra-modern silhouette with knit upper and suede overlays is geared to the style-driven shoe lover. Plush Fresh Foam midsole cushioning helps keep you comfortable all day long, while NDurance rubber outsole technology provides durability to help you go the distance.",
    prize:"2800",
    offerPize:2750, qty:1
},
{ id:"16",
name:"WOMEN'S RYKA PINNACLE XT TRAINING SHOES",
    type:"women",
    brand:'Adidas',
    src:"https://i8.amplience.net/s/scvl/146064_323450_SET/1?fmt=auto&$webPdpProduct$" ,
    des:"Find the pinnacle of performance in this sleek and supportive high-impact cross-trainer. BEST FOR: High-intensity workouts and classes. PERFORMANCE TECH: Exceptional cushioning throughout for standout comfort. MADE FOR WOMEN FIT: Designed for a woman’s unique foot shape, muscle movement, and build with a narrower heel, roomier toe, and softer foot cushioning. ",
    prize:"4500",
    offerPize:4020, qty:1
},
{ id:"17",
name:"WOMEN'S KATELYNN LACE UP BOOTIES",
    type:"women",
    brand:'New York',
    src:"https://i8.amplience.net/s/scvl/149589_322045_SET/1?fmt=auto&$webPdpProduct$" ,
    des:"Diamond like pattern, cushioned collar, lace-up style. The Katelyn is carefully embellished by a double chain accent at the lugged sole and an ankle strap.",
    prize:"4899",
    offerPize:4799, qty:1
},
{ id:"18",
name:"Women's Nike Legend  Shoes Breathable ",
    type:"women",
    brand:'Nike',
    src:"https://i8.amplience.net/s/scvl/141779_302317_SET/1?fmt=auto" ,
    des:"Breathable mesh upper with padded collar and fabric liningLace-up closure for a secure fit Absorbent fabric lined insoleSculpted foam midsole and durable rubber outsole with traction designNike® branding detail",
    prize:"4900",
    offerPize:4580, qty:1
},

{ id:"19",
name:"Women's Skechers Shoes Rockport",
    type:"women",
    brand:'Skechers',
    src:"https://i8.amplience.net/s/scvl/113312_232621_SET/1?fmt=auto" ,
    des:" Absorbent fabric lined insoleSculpted foam midsole and durable rubber outsole with traction design branding detail",
    prize:"4800",
    offerPize:4480, qty:1
},
{ id:"22",
name:"Men's Rockport Storm Surge Boots",
    type:"men",
    brand:' ADIPRENE',
    src:"https://i8.amplience.net/s/scvl/139183_295089_SET/1?fmt=auto&$webPdpProduct$" ,
    des:" Men's Rockport Waterproof Leather Ankle Boots. Stand up to the elements with tailored styling in the Rockport Storm Surge Boot! These ankle boots feature waterproof leather uppers, slip resistant rubber traction outsole, and ADIPRENE® by Adidas sport technology for all day comfort with shock absorption in the heel. From the job site to a casual night out, you'll love the look and feel of the Rockport Storm Surge Boot!",
    prize:"4800",
    offerPize:4480, qty:1
},
{ id:"23",
name:"Men's Adidas Daily 3.0 Sneakers",
    type:"sports",
    brand:'Adidas',
    src:"https://i8.amplience.net/s/scvl/106169_268283_SET/1?fmt=auto&$webPdpProduct$" ,
    des:" Microsuede upper with stitching and stud details Approx. 4 inch shaft height with fabric lining Easy zip-up side closure Approx. 2 inch heel  Flattering almond to Rubber midsole with faux woodgrain design and durable outsolel",
    prize:"4700",
    offerPize:4470, qty:1
},
{ id:"24",
name:"Men's Nike Air Max Excee Sneakers",
    type:"sports",
    brand:'Nike',
    src:"https://i8.amplience.net/s/scvl/103543_302067_SET/1?fmt=auto" ,
    des:" Celebrate a classic throwback favorite with a fresh new lens with the Nike Air Max Excee. Inspired by the Nike Air Max 90, these sneaks are anything but weak - crafted with a durable, yet breathable upper, a supportive and stylish visible Air midsole, and a super soft cushioned insole, it'll be a challenge not to love them the moment you lace them up! But wait - there's more! The Air Max Excee sports some serious versatility in it's design, which means you can effortlessly jump from the court to playing with the kiddos in your dad shorts in record timing.",
    prize:"4500",
    offerPize:4490, qty:1
},
{ id:"25",
name:"Men's ASICS Gel Venture 8 Running Shoes",
    type:"sports",
    brand:'ASICS',
    src:"https://i8.amplience.net/s/scvl/114873_237093_SET/1?fmt=auto" ,
    des:" Celebrate a classic throwback favorite with a fresh new lens with the Nike Air Max Excee. Inspired by the Nike Air Max 90, these sneaks are anything but weak - crafted with a durable, yet breathable upper, a supportive and stylish visible Air midsole, and a super soft cushioned insole, it'll be a challenge not to love them the moment you lace them up! But wait - there's more! The Air Max Excee sports some serious versatility in it's design, which means you can effortlessly jump from the court to playing with the kiddos in your dad shorts in record timing.",
    prize:"5850",
    offerPize:5090, qty:1
},
{ id:"26",
name:"Men's Nike Renew Nike Air Max Excee",
    type:"sports",
    brand:'Nike',
    src:"https://i8.amplience.net/s/scvl/127462_301993_SET/1?fmt=auto" ,
    des:"  Favorite with a fresh new lens with the Nike Air Max Excee. Inspired by the Nike Air Max 90, these sneaks are anything but weak - crafted with a durable, yet breathable upper, a supportive and stylish visible Air midsole, and a super soft cushioned insole, it'll be a challenge not to love them the moment you lace them up! But wait - there's more! The Air Max Excee sports some serious versatility in it's design, which means you can effortlessly jump from the court to playing with the kiddos in your dad shorts in record timing.",
    prize:"4800",
    offerPize:4090, qty:1
},
{ id:"27",
name:"Girls' Adidas Little Kid & Big Kid ",
    type:"sports",
    brand:'Adidas',
    src:"https://i8.amplience.net/s/scvl/120506_315539_SET/1?fmt=auto" ,
    des:"  Favorite with a fresh new lens with the Nike Air Max Excee. Inspired by the Nike Air Max 90, these sneaks are anything but weak - crafted with a durable, yet breathable upper, a supportive and stylish visible Air midsole, and a super soft cushioned insole, it'll be a challenge not to love them the moment you lace them up! But wait - there's more! The Air Max Excee sports some serious versatility in it's design, which means you can effortlessly jump from the court to playing with the kiddos in your dad shorts in record timing.",
    prize:"5000",
    offerPize:4900, qty:1
},
{ id:"28",
name:"Boys' New Balance Little Kid Playgruv Wide Width ",
    type:"sports",
    brand:'New Balance',
    src:"https://i8.amplience.net/s/scvl/115991_271272_SET/1?fmt=auto" ,
    des:"  Favorite with a fresh new lens with the Nike Air Max Excee. Inspired by the Nike Air Max 90, these sneaks are anything but weak - crafted with a durable, yet breathable upper, a supportive and stylish visible Air midsole, and a super soft cushioned insole, it'll be a challenge not to love them the moment you lace them up! But wait - there's more! The Air Max Excee sports some serious versatility in it's design, which means you can effortlessly jump from the court to playing with the kiddos in your dad shorts in record timing.",
    prize:"5700",
    offerPize:4990, qty:1
},
{ id:"29",
name:"Girls' Fila Little Kid & Big Kid Wide Width ",
    type:"sports",
    brand:'Fila',
    src:"https://i8.amplience.net/s/scvl/106271_266952_SET/1?fmt=auto" ,
    des:"  Favorite with a fresh new lens with the Nike Air Max Excee. Inspired by the Nike Air Max 90, these sneaks are anything but weak - crafted with a durable, yet breathable upper, a supportive and stylish visible Air midsole, and a super soft cushioned insole, it'll be a challenge not to love them the moment you lace them up! But wait - there's more! The Air Max Excee sports some serious versatility in it's design, which means you can effortlessly jump from the court to playing with the kiddos in your dad shorts in record timing.",
    prize:"4700",
    offerPize:3990, qty:1
},
{ id:"30",
name:"Girls' Skechers Toddler & Little Kid Jumpsters",
    type:"sports",
    brand:'Skechers',
    src:"https://i8.amplience.net/s/scvl/112341_230188_SET/1?fmt=auto" ,
    des:"  Favorite with a fresh new lens with the Skechers. Inspired by the Nike Air Max 90, these sneaks are anything but weak - crafted with a durable, yet breathable upper, a supportive and stylish visible Air midsole, and a super soft cushioned insole, it'll be a challenge not to love them the moment you lace them up! But wait - there's more! The Air Max Excee sports some serious versatility in it's design, which means you can effortlessly jump from the court to playing with the kiddos in your dad shorts in record timing.",
    prize:"5790",
    offerPize:4999, qty:1
},
{ id:"31",
name:"Girls' Puma Infant & Toddler SR Rift Slip-On ",
    type:"sports",
    brand:'Puma',
    src:"https://i8.amplience.net/s/scvl/111634_255515_SET/1?fmt=auto" ,
    des:"  Favorite with a fresh new lens with the Puma Excee. Inspired by the Nike Air Max 90, these sneaks are anything but weak - crafted with a durable, yet breathable upper, a supportive and stylish visible Air midsole, and a super soft cushioned insole, it'll be a challenge not to love them the moment you lace them up! But wait - there's more! The Air Max Excee sports some serious versatility in it's design, which means you can effortlessly jump from the court to playing with the kiddos in your dad shorts in record timing.",
    prize:"1500",
    offerPize:1499, qty:1
},
{ id:"32",
name:"Girls' Under Armour Big Kid Assert ",
    type:"sports",
    brand:'Armour ',
    src:"https://i8.amplience.net/s/scvl/115956_269550_SET/1?fmt=auto" ,
    des:"  Favorite with a fresh new lens with the Armour  Excee. Inspired by the Nike Air Max 90, these sneaks are anything but weak - crafted with a durable, yet breathable upper, a supportive and stylish visible Air midsole, and a super soft cushioned insole, it'll be a challenge not to love them the moment you lace them up! But wait - there's more! The Air Max Excee sports some serious versatility in it's design, which means you can effortlessly jump from the court to playing with the kiddos in your dad shorts in record timing.",
    prize:"1900",
    offerPize:1899, qty:1
},
];

